import { useState } from 'react'
import { supabase } from '../services/supabase'
import { AdminSession, DashboardPage } from '../types'
import ReservationsManagement from './ReservationsManagement'
import CampaignsManagement from './CampaignsManagement'
import CampaignComposer from './CampaignComposer'

interface DashboardProps {
  session: AdminSession
  onLogout: () => void
}

export function Dashboard({ session, onLogout }: DashboardProps) {
  const [currentPage, setCurrentPage] = useState<DashboardPage>('reservations')
  const [editingCampaignId, setEditingCampaignId] = useState<string | undefined>()

  const handleLogout = async () => {
    await supabase.auth.signOut()
    onLogout()
  }

  // Campaign navigation handlers
  const handleCampaignNavigation = (page: 'campaignComposer', campaignId?: string) => {
    setEditingCampaignId(campaignId)
    setCurrentPage(page)
  }

  const handleCampaignComposerNavigation = (page: 'campaigns') => {
    setEditingCampaignId(undefined)
    setCurrentPage(page)
  }

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <div className="admin-layout__sidebar">
        {/* Logo */}
        <div className="admin-layout__logo">
          <h1>EJ's Admin</h1>
        </div>

        {/* Navigation */}
        <nav className="admin-layout__nav">
          <button
            onClick={() => setCurrentPage('reservations')}
            className={`admin-layout__nav-item ${
              currentPage === 'reservations' ? 'admin-layout__nav-item--active' : ''
            }`}
          >
            <i className="fa-sharp fa-thin fa-calendar-days" aria-hidden="true"></i>
            Reservations
          </button>

          <button
            onClick={() => setCurrentPage('campaigns')}
            className={`admin-layout__nav-item ${
              currentPage === 'campaigns' || currentPage === 'campaignComposer'
                ? 'admin-layout__nav-item--active'
                : ''
            }`}
          >
            <i className="fa-sharp fa-thin fa-envelope" aria-hidden="true"></i>
            Marketing
          </button>
        </nav>

        {/* User info */}
        <div className="admin-layout__user">
          <div className="admin-layout__user-info">
            <div>
              <p className="admin-layout__user-email">{session.user.email}</p>
              <p className="admin-layout__user-role">Administrator</p>
            </div>
            <button
              onClick={handleLogout}
              className="admin-layout__user-logout"
              title="Logout"
            >
              <i className="fa-sharp fa-thin fa-right-from-bracket" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="admin-layout__main">
        <div className="container">
          {currentPage === 'reservations' && <ReservationsManagement />}

          {/* Marketing Pages */}
          {currentPage === 'campaigns' && (
            <CampaignsManagement onNavigate={handleCampaignNavigation} />
          )}
          {currentPage === 'campaignComposer' && (
            <CampaignComposer
              campaignId={editingCampaignId}
              onNavigate={handleCampaignComposerNavigation}
            />
          )}
        </div>
      </div>
    </div>
  )
}
